<template>
  <ReportWrapper>
    <template #actions>
      <div class="flex gap-x-2">
        <CfsDateField v-model="selectedDateRange" placeholder="Select date range" range />
      </div>

      <v-btn color="primary" :loading="isLoading" @click="download">
        <v-icon size="1rem" class="mr-1">mdi-tray-arrow-down</v-icon>
        <span>Download</span>
      </v-btn>
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFile } from '@/helpers/download';
import { useToast } from '@/composables/useToast';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';
import { AxiosError } from 'axios';

export default defineComponent({
  name: 'WindowReleaseReport',
  components: {
    ReportWrapper,
  },
  setup() {
    const toast = useToast();

    const selectedDateRange = ref<{ start: string; end: string } | null>(null);

    const { useDownloadWindowReleaseReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadWindowReleaseReport();

    const download = async () => {
      if (!selectedDateRange.value) return toast.info('Please select date range.');

      try {
        const data = await downloadReport({
          startDate: selectedDateRange.value.start,
          endDate: selectedDateRange.value.end,
        });

        if (!data) return;

        downloadFile(data.base64Data, data.filename ?? 'Window Release Report');
      } catch (error) {
        const axiosError = error as AxiosError<string>;
        toast.error(axiosError?.response?.data!);
      }
    };

    return { selectedDateRange, isLoading, download };
  },
});
</script>
